const createConstant = (name, value) => {
    Object.defineProperty(module.exports, name, {
        value,
        enumerable: true,
        writable: false,
    });
};

createConstant('WINDOWS', 'windows');
createConstant('LINUX', 'linux');

createConstant('M11_6_09', 'm11_6_09');
createConstant('M11_6_06', 'm11_6_06');
createConstant('M11_6_03', 'm11_6_03');
createConstant('M11_5_12', 'm11_5_12');
createConstant('M11_5_09', 'm11_5_09');
createConstant('M11_5_06', 'm11_5_06');
createConstant('M11_5_03', 'm11_5_03');
createConstant('M11_4_12', 'm11_4_12');
createConstant('CUSTOM_INSTALL', 'custom_install');
createConstant('EXPRESS_INSTALL', 'express_install');

createConstant('LINUX_11_6_09', 'linux_11_6_09');
createConstant('LINUX_11_6_06', 'linux_11_6_06');
createConstant('LINUX_11_6_03', 'linux_11_6_03');
createConstant('LINUX_11_5_12', 'linux_11_5_12');
createConstant('LINUX_11_5_09', 'linux_11_5_09');
createConstant('LINUX_11_5_06', 'linux_11_5_06');
createConstant('LINUX_11_5_03', 'linux_11_5_03');
createConstant('LINUX_11_4_12', 'linux_11_4_12');

createConstant('WINDOWS_11_6_09_CUSTOM', 'windows_11_6_09_custom');
createConstant('WINDOWS_11_6_09_EXPRESS', 'windows_11_6_09_express');
createConstant('WINDOWS_11_6_06_CUSTOM', 'windows_11_6_06_custom');
createConstant('WINDOWS_11_6_06_EXPRESS', 'windows_11_6_06_express');
createConstant('WINDOWS_11_6_03_CUSTOM', 'windows_11_6_03_custom');
createConstant('WINDOWS_11_6_03_EXPRESS', 'windows_11_6_03_express');
createConstant('WINDOWS_11_5_12_CUSTOM', 'windows_11_5_12_custom');
createConstant('WINDOWS_11_5_12_EXPRESS', 'windows_11_5_12_express');
createConstant('WINDOWS_11_5_09_CUSTOM', 'windows_11_5_09_custom');
createConstant('WINDOWS_11_5_09_EXPRESS', 'windows_11_5_09_express');
createConstant('WINDOWS_11_5_06_CUSTOM', 'windows_11_5_06_custom');
createConstant('WINDOWS_11_5_06_EXPRESS', 'windows_11_5_06_express');
createConstant('WINDOWS_11_5_03_CUSTOM', 'windows_11_5_03_custom');
createConstant('WINDOWS_11_5_03_EXPRESS', 'windows_11_5_03_express');
createConstant('WINDOWS_11_4_12_CUSTOM', 'windows_11_4_12_custom');
createConstant('WINDOWS_11_4_12_EXPRESS', 'windows_11_4_12_express');

//Page Name
createConstant('LIN_CUSTOMERINFO_INSTALLDIR', 'linCustomerInfoAndInstallDir');
createConstant('LIN_FEATURESELECTION', 'linFeatureSelection');
createConstant('LIN_IDENTITYSERVERCONFIG1', 'linIdentityServerConfig1');
createConstant('LIN_IDENTITYSERVERCONFIG2', 'linIdentityServerConfig2');
createConstant('LIN_IDENTITYSERVERCONFIG3', 'linIdentityServerConfig3');
createConstant('LIN_IDENTITYMANAGERCONFIG', 'linIdentityManagerConfig');
createConstant('LIN_TELEMETRYSERVERCONFIG', 'linTelemetryServerConfig');
createConstant('LIN_TOPOLOGYCONFIG', 'linTopologyConfig');
createConstant('LIN_REMOTEREPOSITORY', 'linRemoteRepository');
createConstant('LIN_REGISTERASSERVICE', 'linRegisterAsService');
createConstant('LIN_SUMMARY', 'linSummary');
createConstant('LIN_FINALPAGE', 'linFinalPage');
createConstant('WIN_CUSTOMERINFO_INSTALLDIR', 'winCustomerInfoAndInstallDir');
createConstant('WIN_FEATURESELECTION', 'winFeatureSelection');
createConstant('WIN_REMOTEREPOSITORY', 'winRemoteRepository');
createConstant('WIN_TOPOLOGYCONFIG', 'winTopologyConfig');
createConstant('WIN_IDENTITYCONFIG', 'winIdentityConfig');
createConstant('WIN_TELEMETRYCONFIG', 'winTelemetryConfig');
createConstant('WIN_WEB_MobileVDS', 'winWebAndMobileVDS');
createConstant('WIN_PORTAL_mdxVDS', 'winPortalAndmdxVDS');
createConstant('WIN_mdxVDS', 'winMdxVDS');
createConstant('WIN_OFFICECONFIG', 'winOfficeConfig');
createConstant('WIN_INTELLIGENCECONFIG', 'winIntelligenceConfig');
createConstant('WIN_NARROWCASTCONFIG', 'winNarrowcastConfig');
createConstant('WIN_SUMMARY', 'winSummary');
createConstant('WIN_FINALPAGE', 'winFinalPage');
